import { API, Auth } from "aws-amplify";
import { addMinutes } from "date-fns";
import awsmobile from "../aws-exports";
import { buildUrlParams, passwordGenerator } from "../utils";


const API_NAME = awsmobile.aws_cloud_logic_custom[0].name;

const headersForApi = async () => ({
  headers: {
    Authorization: `Bearer ${(await Auth.currentSession())
      .getIdToken()
      .getJwtToken()}`,
  },
});

Auth.configure({
  authenticationFlowType: 'CUSTOM_AUTH',
})
const authProvider = {
  // authentication
  login: ({ username, password }) => {
    console.log("LOGIN")
    return new Promise(async (resolve, reject) => {
      try {
        const auth = await Auth.signIn(username, password);
        if (
          auth.challengeName &&
          auth.challengeName === "NEW_PASSWORD_REQUIRED"
        ) {
          resolve({ redirectTo: '/change-password-temp', status: 'NEW_PASSWORD_REQUIRED', user: username, password: password, auth: auth })
        } else {
          if (auth.challengeName &&
            auth.challengeName === "CUSTOM_CHALLENGE") {
            resolve({ redirectTo: '/verify-otp', status: 'CUSTOM_CHALLENGE', user: username, password: password, auth: auth })
          } else {
            if ((auth.attributes['custom:password_update'] !== undefined && auth.attributes['custom:password_update'] !== "0" && auth.attributes['custom:password_update'] !== 0 || auth.attributes["custom:role"] === "Root")) {
              const totalExpirationDate = Number(auth.attributes['custom:password_update']) + Number(auth.attributes['custom:password_expiry_time']);
              let currentDate = new Date().getTime();
              if (currentDate < totalExpirationDate) {
                let newSessionTime = addMinutes(new Date(), 10);
                window.localStorage.setItem("sessionTime", newSessionTime);
                if (auth.attributes["custom:role"] !== "Root") {
                  window.localStorage.setItem(
                    "businessIdSelected",
                    auth.attributes["custom:business"]
                  );
                }

                if (
                  auth.attributes["custom:role"] !== "Root" &&
                  auth.attributes["custom:role"] !== "Admin"
                ) {
                  window.localStorage.setItem(
                    "branchIdSelected",
                    auth.attributes["custom:branch_id"]
                  );
                }
                resolve(auth);
              } else {
                resolve({ redirectTo: '/change-password-temp', status: 'NEW_PASSWORD_REQUIRED', user: username, password: password, auth: auth })
              }

            } else {
              resolve({ redirectTo: '/change-password-temp', status: 'NEW_PASSWORD_REQUIRED', user: username, password: password, auth: auth })
            }
          }

        }
      } catch (err) {
        reject(err);
      }
    });
  },

  checkError: (error) => {
    console.log("CHECK ERROR")
    console.error(error);
    const status = error.status !== undefined ? error.status : error.response.status;

    if (status === 401 || status === 403) {
      window.location.href = "/";
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: async () => {
    try {
      console.log("CHECK AUTH")
      const session = await Auth.currentSession();
      if (session.isValid()) {
        return Promise.resolve();
      }
      return Promise.reject({ redirectTo: "/login" });
    } catch (error) {
      return Promise.reject(error);
    }

  },

  logout: async () => {
    console.log("LOGOUT")
    await Auth.signOut();
    localStorage.removeItem("sessionTime");
    localStorage.removeItem("businessIdSelected");
    localStorage.removeItem("branchIdSelected");
    localStorage.removeItem("email");
    return Promise.resolve();
  },

  getIdentity: async () => {
    console.log("GET IDENTITY")
    try {
      const session = await Auth.currentSession();
      const payload = session.getIdToken().payload;
      console.log(payload)
      const data = {
        email: payload["cognito:username"],
        name: payload.name,
        lastName: payload["custom:last_name"],
        business: payload["custom:business"],
        branch: payload["custom:branch_id"],
        permission: payload["custom:role"],
      };
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // authorization
  getPermissions: async () => {
    console.log("GET PERMISSION")
    try {
      const session = await Auth.currentSession();
      if (session.isValid()) {
        const payload = session.getIdToken().payload;
        const role = payload["custom:role"];
        return Promise.resolve(role);
      }
      return Promise.resolve("guest");
    } catch (error) {
      return Promise.resolve("guest");
    }
  },

  // Custom methods
  checkUserExists: (userEmail) => {
    let params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Username: userEmail
    };

    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.post(API_NAME, `/users/checkUserExists`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve(true);
      })
        .catch((err) => {
          if (err.response.data.error.code === 'UserNotFoundException') {
            resolve(false);
          } else {
            reject(err);
          }
        });
    });

  },

  // Custom methods
  checkUserExists: (userEmail) => {
    let params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Username: userEmail
    };

    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.post(API_NAME,`/users/checkUserExists`,
        {headers: getHeaders.headers,
          body: params }
      ).then((res) => {
          resolve(true);
        })
        .catch((err) => {
          if (err.response.data.error.code === 'UserNotFoundException') {
            resolve(false);
          } else {
            reject(err);
          }
        });
    });

  },

  // Custom methods
  createUser: (userEmail, firstName, lastName, business, branch, role, password_update, password_expiry_time, resend = false) => {
    let newPassword = passwordGenerator(10);
    let params = {
      Username: userEmail,
      TemporaryPassword: newPassword,
      UserPoolId: awsmobile.aws_user_pools_id,
      UserAttributes: [
        { Name: "email", Value: userEmail },
        { Name: "name", Value: firstName },
        { Name: "email_verified", Value: "true" },
        { Name: "custom:last_name", Value: lastName },
        { Name: "custom:business", Value: business },
        { Name: "custom:branch_id", Value: branch },
        { Name: "custom:role", Value: role },
        { Name: "custom:password_update", Value: password_update },
        { Name: "custom:password_expiry_time", Value: password_expiry_time }
      ],
    };
    if (resend) {
      params.MessageAction = "RESEND"
    }
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.post(API_NAME, `/users`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve(res.user);
      })
        .catch((err) => {
          console.log(err)
          reject(err);
        });
    });
  },

  adminSetNewPassword: (username, newPassword, permanent = true) => {
    let params = {
      Username: username,
      Password: newPassword,
      Permanent: permanent,
      UserPoolId: awsmobile.aws_user_pools_id,
    };
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.put(API_NAME, `/users/adminSetNewPassword`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve(res.user);
      })
        .catch((err) => {
          console.log(err)
          reject(err);
        });
    });
  },

  editUser: (username, firstName, lastName, business, branch, role) => {
    let params = {
      Username: username,
      UserPoolId: awsmobile.aws_user_pools_id,
      UserAttributes: [
        { Name: "email", Value: username },
        { Name: "name", Value: firstName },
        { Name: "custom:last_name", Value: lastName },
        { Name: "custom:business", Value: business },
        { Name: "custom:branch_id", Value: branch },
        { Name: "custom:role", Value: role },
      ],
    };
    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.put(API_NAME, `/users`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve({
          data: res.user,
          total: 1,
        });
      })
        .catch((err) => {
          console.log(err)
          reject(err);
        });
    });
  },

  editUserAttribute: (params) => {

    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.put(API_NAME, `/users`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve({
          data: res.user,
          total: 1,
        });
      })
        .catch((err) => {
          console.log(err)
          reject(err);
        });
    });
  },

  getUsers: async (userParams) => {
    let paramsFilters = "";
    if (userParams.length !== 0) {
      paramsFilters = `${Object.keys(userParams[0])[0]}^="${
        Object.values(userParams[0])[0]
      }"`;
    }
    let params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      AttributesToGet: [
        "email",
        "name",
        "custom:last_name",
        "custom:business",
        "custom:branch_id",
        "custom:role",
        "custom:password_update",
        "custom:password_expiry_time"
      ],
    };
    if(paramsFilters){
      params.Filter = paramsFilters
    }

    const queryString = new URLSearchParams(params).toString();

    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.get(API_NAME, `/users?${queryString}`,
        getHeaders,
      ).then((res) => {
        resolve(res.users);
      })
        .catch((err) => {
          console.log(err.response.data.message)
          err.message = err.response.data.message
          reject(err);
        });
    });
  },

  deleteUser: (username) => {
    let params = {
      Username: username,
      UserPoolId: awsmobile.aws_user_pools_id,
    };

    return new Promise(async (resolve, reject) => {
      const getHeaders = await headersForApi();
      API.del(API_NAME, `/users`,
        {
          headers: getHeaders.headers,
          body: params
        }
      ).then((res) => {
        resolve(res.user);
      })
        .catch((err) => {
          console.log(err)
          reject(err);
        });
    });
  },
};

export default authProvider;
